import * as React from "react";
import Dialog from "../Dialog";

import { IUser } from "../../../types";

import { clone, pull } from "lodash";

interface Props {
    onCloseDialog: () => any;
    doctors: IUser[];
}

interface State {
}

const s = require("./ListDoctorsDialog.scss");

class ListDoctorsDialog extends React.Component<Props, State> {
    constructor(props: Props, context: any) {
        super(props, context);

    }

    render(): JSX.Element {
        const doctors = this.props.doctors.map(contact => {
            return (
                <li key={contact.id}>
                    <label>
                        {contact.name}
                    </label>
                </li>
            );
        });

        return (
            <Dialog
                onCloseDialog={this.props.onCloseDialog}
            >
                <div className={s.listDoctors}>
                    <h2>Profissionais cadastrados</h2>
                    <ul className={s.doctors}>
                        {doctors}
                    </ul>                     
                </div>
            </Dialog>
        );
    }
}

export default ListDoctorsDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/ListDoctorsDialog/index.tsx